@use "../../styles/responsive";

$component-name: "card";
$header-component-name: "card-title";

.card {
  --ixf-card-background: var(--ixf-color-background);
  --ixf-card-border: 1px solid var(--ixf-color-separator);
  --ixf-card-border-radius: var(--ixf-border-radius-2);

  background: var(--ixf-card-background);
  border-radius: var(--ixf-card-border-radius);
  border: var(--ixf-card-border);

  &.isBorderless {
    --ixf-card-border: none;
  }

  .title {
    border-radius: var(--ixf-card-border-radius) var(--ixf-card-border-radius) 0
      0;
    background: var(--ixf-color-neutral-xlt);
    border-bottom: var(--ixf-card-border);

    &:only-child {
      border-radius: var(--ixf-card-border-radius);
    }

    @include responsive.responsive-props(
      $header-component-name,
      "padding-left",
      "padding-left"
    );
    @include responsive.responsive-props(
      $header-component-name,
      "padding-right",
      "padding-right"
    );
    @include responsive.responsive-props(
      $header-component-name,
      "padding-top",
      "padding-top"
    );
    @include responsive.responsive-props(
      $header-component-name,
      "padding-bottom",
      "padding-bottom"
    );
  }

  .content {
    @include responsive.responsive-props(
      $component-name,
      "padding-left",
      "padding-left"
    );
    @include responsive.responsive-props(
      $component-name,
      "padding-right",
      "padding-right"
    );
    @include responsive.responsive-props(
      $component-name,
      "padding-top",
      "padding-top"
    );
    @include responsive.responsive-props(
      $component-name,
      "padding-bottom",
      "padding-bottom"
    );
  }
}
